import { connect } from 'react-redux'
import { CreateGroupForm as Form } from './CreateGroupForm'
import { AppStateType } from '../../reducers'
import { selectGroup } from '../../selectors/group'

const mapStateToProps = (state: AppStateType) => ({
  group: selectGroup(state),
})

export const CreateGroupForm = connect(mapStateToProps)(Form)
